import { PreownedTwsSyncPage } from "./PreownedPlaceholderPage";
import { PreownedWatchesPage } from "./PreownedWatchesPage";
import { PreownedEditWatchPage } from "./PreownedEditWatchPage";
import { PreownedGeneratorPage } from "./PreownedGeneratorPage";
import { PreownedRefreshMsrpPage } from "./PreownedRefreshMsrpPage";
import { PreownedSoldExpiresPage } from "./PreownedSoldExpiresPage";
import { PREOWNED_PT_FEATURES } from "../../themes";
import { PreownedAttributesPage } from "./PreownedAttributesPage";

export * from "./PreownedPlaceholderPage";
export * from "./PreownedAttributesPage";
export * from "./PreownedWatchesPage";
export * from "./PreownedEditWatchPage";
export * from "./PreownedGeneratorPage";
export * from "./PreownedRefreshMsrpPage";
export * from "./PreownedSoldExpiresPage";
export * from "./PreownedImages";

/**
 * Pre-owned admin routes. Every path sits under /preowned, which is what puts
 * the app into pre-owned mode — see themes/adminMode.js.
 */
export const PreownedPages = {
  preownedWatches: {
    anon: false,
    path: "/preowned/watches",
    title: "Pre-Owned Watches",
    type: "PAGE_PREOWNED_WATCHES",
    view: PreownedWatchesPage,
  },
  preownedAddWatch: {
    anon: false,
    path: "/preowned/add-watch",
    title: "Add Pre-Owned Watch",
    type: "PAGE_PREOWNED_ADD_WATCH",
    view: PreownedEditWatchPage,
  },
  preownedEditWatch: {
    anon: false,
    path: "/preowned/edit-watch/:id",
    title: "Edit Pre-Owned Watch",
    type: "PAGE_PREOWNED_EDIT_WATCH",
    view: PreownedEditWatchPage,
  },
  preownedAddAccessory: {
    anon: false,
    path: "/preowned/add-accessory",
    title: "Add Accessory",
    type: "PAGE_PREOWNED_ADD_ACCESSORY",
    view: PreownedEditWatchPage,
  },
  preownedEditAccessory: {
    anon: false,
    path: "/preowned/edit-accessory/:id",
    title: "Edit Accessory",
    type: "PAGE_PREOWNED_EDIT_ACCESSORY",
    view: PreownedEditWatchPage,
  },
  preownedGenerator: {
    anon: false,
    path: "/preowned/generator",
    title: "Email Generator",
    type: "PAGE_PREOWNED_GENERATOR",
    view: PreownedGeneratorPage,
  },
  preownedRefreshMsrp: {
    anon: false,
    path: "/preowned/refresh-msrp",
    title: "Refresh MSRP",
    type: "PAGE_PREOWNED_REFRESH_MSRP",
    view: PreownedRefreshMsrpPage,
  },
  preownedSoldExpires: {
    anon: false,
    path: "/preowned/sold-expires",
    title: "Sold Expires At",
    type: "PAGE_PREOWNED_SOLD_EXPIRES",
    view: PreownedSoldExpiresPage,
  },
  // PT only. TheWatchSource is a PT sales channel; TPC ships the same build
  // with REACT_APP_PREOWNED_PT_FEATURES=false and the route never registers.
  ...(PREOWNED_PT_FEATURES
    ? {
        preownedTwsSync: {
          anon: false,
          path: "/preowned/tws-sync",
          title: "Sync with TWS",
          type: "PAGE_PREOWNED_TWS_SYNC",
          view: PreownedTwsSyncPage,
        },
      }
    : {}),
  preownedAttributes: {
    anon: false,
    path: "/preowned/attributes/:type",
    title: "Pre-Owned Attributes",
    type: "PAGE_PREOWNED_ATTRIBUTES",
    view: PreownedAttributesPage,
  },
};
export default PreownedPages;

export const PreownedArea = {
  pages: PreownedPages,
};
